var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 18,
    viewBox: "0 0 43 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72069 10.4627L8.12788 8.97573C8.95112 8.61583 9.60842 7.95853 9.96832 7.13529L11.4553 3.7281C11.5717 3.46303 11.9445 3.46303 12.0609 3.7281L13.5479 7.13529C13.9078 7.95853 14.5651 8.61583 15.3884 8.97573L18.802 10.4649C19.0649 10.5791 19.0671 10.9541 18.802 11.0705L15.3302 12.6049C14.5091 12.9691 13.8539 13.6286 13.4983 14.4539L12.0587 17.7965C11.9445 18.0616 11.5674 18.0637 11.4532 17.7965L9.96832 14.3936C9.60842 13.5704 8.95112 12.9131 8.12788 12.5532L4.72069 11.0662C4.45562 10.9498 4.45562 10.577 4.72069 10.4606V10.4627Z",
    fill: "#EC0100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.452929 4.01074L2.42268 3.15087C2.89895 2.94398 3.27824 2.56253 3.48513 2.08841L4.34501 0.118664C4.41182 -0.0343465 4.62733 -0.0343465 4.69413 0.118664L5.55401 2.08841C5.7609 2.56468 6.14235 2.94398 6.61647 3.15087L8.58837 4.01074C8.74138 4.07755 8.74138 4.29306 8.58837 4.35987L6.58198 5.24776C6.10787 5.4568 5.72857 5.84041 5.52384 6.31668L4.69198 8.24764C4.62517 8.40065 4.40751 8.40065 4.3407 8.24764L3.48298 6.2822C3.27609 5.80593 2.89464 5.42663 2.42052 5.21975L0.450776 4.35987C0.297765 4.29306 0.297765 4.07755 0.450776 4.01074H0.452929Z",
    fill: "#EC0100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0024 3.85742V16.3889H40.3125V3.85742H43.0024Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6676 16.3889H24.7852L29.1772 3.85742H32.6436L37.0295 16.3889H34.147L30.9601 6.72106H30.8607L27.6676 16.3889ZM27.4875 11.4632H34.2961V13.5314H27.4875V11.4632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo);
export default __webpack_public_path__ + "static/media/ai-logo.9530c165065f952f79d20562c0553944.svg";
export { ForwardRef as ReactComponent };